<script lang="ts">
  export let fill: string = "yellow";
  export let direction: string = "N";

  const directions: {[index:string] : number} = {
    "N": 0,
    "NE": 45,
    "E": 90,
    "SE": 135,
    "S": 180,
    "SW": 225,
    "W": 270,
    "NW": 315
  };

</script>

<div class="svg-box">
  <svg
    {fill}
    height="100%"
    width="100%"
    class="vector svg-content"
    style="--direction: {(directions[direction] + 180 )+"deg"}"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="rotate(45 10 10)">
      <path
        d="M10 0C4.489 0 0 4.489 0 10C0 15.511 4.489 20 10 20C15.511 20 20 15.511 20 10C20 4.489 15.511 0 10 0ZM10 2C14.4301 2 18 5.56988 18 10C18 14.4301 14.4301 18 10 18C5.56988 18 2 14.4301 2 10C2 5.56988 5.56988 2 10 2ZM6 6V11.6562L8.12109 9.53516L12.5078 13.9219L13.9219 12.5078L9.53516 8.12109L11.6562 6H6Z"
      />
    </g>
  </svg>
</div>

<style>
  @keyframes animateVector {
    0% {
      rotate: 0;
    }
    100% {
      rotate: var(--direction);
    }
  }
  .vector {
    animation: animateVector 1s forwards;
  }
</style>
